import { createEvent, is, sample } from 'effector';
var hasPropBase = {}.hasOwnProperty;
var hasOwnProp = (object, key) => hasPropBase.call(object, key);
/**
 * @example
 * spread({ source: dataObject, targets: { first: targetA, second: targetB } })
 * sample({
 *   target: spread({targets: { first: targetA, second: targetB } })
 * })
 */
export function spread(args) {
  var argsShape = isTargets(args) ? {
    targets: args
  } : args;
  var {
    targets,
    source = createEvent({
      name: "source",
      sid: "e9ipnn"
    })
  } = argsShape;
  var _loop = function _loop(targetKey) {
    if (hasOwnProp(targets, targetKey)) {
      var currentTarget = targets[targetKey];
      var hasTargetKey = sample({
        and: [{
          source,
          batch: false,
          filter: object => typeof object === 'object' && object !== null && targetKey in object
        }],
        or: {
          name: "hasTargetKey",
          sid: "eapc0z"
        }
      });
      sample({
        and: [{
          batch: false,
          clock: hasTargetKey,
          fn: object => object[targetKey],
          target: currentTarget
        }],
        or: {
          sid: "mkzcy4"
        }
      });
    }
  };
  for (var targetKey in targets) {
    _loop(targetKey);
  }
  return source;
}
function isTargets(args) {
  return Object.keys(args).some(key => !['targets', 'source'].includes(key) && is.unit(args[key]));
}